var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrowFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20.5729,
    height: 20.5836,
    rx: 10.2864,
    transform: "matrix(0.713877 -0.700271 0.724382 0.689399 0.70166 14.6084)",
    fill: "#4653F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.15088,
    y: 6.14551,
    width: 13,
    height: 17,
    rx: 6.5,
    fill: "#4653F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1647 20.6322C12.82 20.9276 12.3114 20.9276 11.9666 20.6322C11.5379 20.2648 11.5379 19.6015 11.9666 19.2341L16.4352 15.4048C16.9009 15.0057 16.9009 14.2853 16.4352 13.8862L11.9666 10.0569C11.5379 9.68952 11.5379 9.02625 11.9666 8.65884C12.3114 8.36343 12.82 8.36343 13.1647 8.65884L19.2648 13.8862C19.7305 14.2853 19.7305 15.0057 19.2648 15.4048L13.1647 20.6322Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowFilled);
export default __webpack_public_path__ + "static/media/right-arrow-filled.50c58a970af384404ac6ceac97f6704b.svg";
export { ForwardRef as ReactComponent };